<template>
  <cv-link class="link-button" :tabindex="tabIndex" :disabled="disabled" v-bind="$attrs">
    <slot />
  </cv-link>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Props
interface Props {
  disabled?: boolean;
  disableKeyboardNav?: boolean;
}

const { disabled = false, disableKeyboardNav = false } = defineProps<Props>();

// Computed
const tabIndex = computed(() => {
  return disableKeyboardNav ? -1 : 0;
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/typo";
@import "@styles/themes/sls-theme/tokens/colors";

.bx--link.link-button {
  @include carbon--type-style("button-01", true);

  &:hover {
    text-decoration: none;
  }

  &:active {
    color: $hover-primary-text;
  }
}
</style>
